import { render, staticRenderFns } from "./AdminSettingIntegrationsMenu.vue?vue&type=template&id=3c138c6e&scoped=true&"
import script from "./AdminSettingIntegrationsMenu.vue?vue&type=script&lang=js&"
export * from "./AdminSettingIntegrationsMenu.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingIntegrationsMenu.vue?vue&type=style&index=0&id=3c138c6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c138c6e",
  null
  
)

export default component.exports